import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
export function updateAction({
  flow,
  action,
  edgeId
}) {
  if (action.isNew()) {
    return flow.removeAction(SpecialActionIds.NEW_ACTION).insertAction({
      action,
      edgeId
    });
  } else {
    return flow.replaceAction(action);
  }
}